import avatar from '../assets/avatar-neutre.png';
import images, { getUrl } from './Images';

export function avatarWithFallbackWhenMissing(image, size = 200, defaultThumbnail) {
  const uri = getUrl(image);
  if (!uri) return defaultThumbnail || avatar;
  return images.square(uri, size);
}
